import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const companies = [
  {
    name: 'Company 1',
    logo: '/logos/Msc7h2FH7FMBhsN9S7CoZWzxH24.avif',
  },
  {
    name: 'Company 2',
    logo: '/logos/RcyRPZUG4Sq6H4coki56KfZ07o.avif',
  },
  {
    name: 'Company 3',
    logo: '/logos/ZesFovqSbfidtmr7dXMsCjxFo5I.avif',
  },
  {
    name: 'Company 4',
    logo: '/logos/bsRs9SFx0wB8LCpHT28r7VQ0rC4.avif',
  },
  {
    name: 'Company 5',
    logo: '/logos/hnsfR6AYiHDBWfYARNlhBKzzxIk.avif',
  },
  {
    name: 'Company 6',
    logo: '/logos/jp8S2x2JaQRf8H4wHq6uhcGjkgs.avif',
  },
  {
    name: 'Company 7',
    logo: '/logos/oex6KVtksedyfJclTTC49gQLqxU.avif',
  },
  {
    name: 'Company 8',
    logo: '/logos/shnslsIA4ueBSjX34RT0EB0ECok.avif',
  }
];

const CompanyLogos = () => {
  const { isDarkMode } = useTheme();
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimated(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const LogoItem = ({ company }) => (
    <motion.div
      key={company.name}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className="flex items-center justify-center min-w-[160px] h-16"
    >
      <img
        src={company.logo}
        alt={`${company.name} logo`}
        className="max-h-8 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity"
      />
    </motion.div>
  );

  return (
    <section className="w-full py-12 overflow-hidden">
      <div className="container mx-auto px-4 mb-8">
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center text-gray-500 dark:text-gray-400 font-medium"
        >
          Trusted by teams at
        </motion.p>
      </div>

      <div 
        className="scroller relative max-w-7xl mx-auto" 
        data-speed="slow"
        data-running={isAnimated}
        data-animated="true"
      >
        <div className="scroller-inner flex flex-nowrap gap-8">
          {companies.map((company) => (
            <LogoItem key={company.name} company={company} />
          ))}
          {companies.map((company) => (
            <LogoItem key={`${company.name}-duplicate`} company={company} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyLogos;
